import * as React from 'react'
import { blue, red, yellow, green } from '@mui/material/colors';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { Appointment, Physician, Patient } from '../../../../models';
import dayjs from 'dayjs';
import PhysicianListWidget from '../physicians/physician-list.component';
import Centered from '../../../../components/Centered';
import PatientListWidget from '../patients/patients-list.component';


const AppointmentView: React.FC<
    {
        appointment: Appointment;
    }
> = ({
    appointment
}) => {
        const getColor = (): string => {
            let color: string;
            switch (appointment.Status) {
                case "Scheduled":
                    color = blue[700];
                    break;
                case "Cancelled":
                    color = red[700];
                    break;
                case "Completed":
                    color = green[700];
                    break;
                default:
                    color = yellow[800]
                    break;
            }
            return color;

        }

        return (
            <Centered >
                <Paper style={{
                    padding: '1em',
                    borderRadius: '14px',
                    border: 'none',
                    width:'80%',

                    maxWidth: '450px',

                }} elevation={2} >
                    <Typography textAlign={'center'} fontWeight="bold"
                        component="h6" variant="h6">
                        {appointment.Title}
                    </Typography>
                    <Typography variant='subtitle1' fontSize={'14px'} color={'#6B779A'} textAlign={'center'} sx={{
                        mt: 1,
                    
                    }}>

                        {dayjs(parseInt(appointment.Date)).format("ddd MMM D, HH:mm")}
                    </Typography>
                    <Typography variant='subtitle1' textAlign={'center'} sx={{
                        mt: 1,


                    }}
                        fontWeight="bold"
                    >
                        {appointment.TypeOfAppointment}
                    </Typography>

                    <Typography variant='subtitle1' color={getColor()} textAlign={'center'} sx={{
                        mt: 1,
                        mb: 2,

                    }}

                    >
                        {appointment.Status}
                    </Typography>
                    <div style={{
                        padding: '1em',
                        borderRadius: '24px',
                        backgroundColor: '#F8F8FA',
                        marginBottom: '2em'
                    }}>
                        <Typography fontWeight={'bold'}>
                            Doctor’s Notes
                        </Typography>

                        <Typography variant='subtitle1' color={'#6B779A'}>
                            {appointment.PhysicianNotes}
                        </Typography>
                    </div>



                    <div>
                        <Typography fontWeight={'bold'}>
                            Physician
                        </Typography>
                        <PhysicianListWidget physician={appointment!.Physician as Physician} />
                    </div>

                    <div>
                        <Typography fontWeight={'bold'}>
                            Patient
                        </Typography>
                        <PatientListWidget patient={appointment!.Patient as Patient} />
                    </div>
                </Paper >
            </Centered>
        )
    }

export default AppointmentView